<template>
  <v-menu class="filter-popup" v-model="addHeaderPopup" :close-on-content-click="false" :nudge-width="0" :nudge-top="10"
    transition="scale-transition" offset-y>
    <template v-slot:activator="{ props }">
      <v-btn @click="openAddHeaderPopup" v-bind="props" size="x-large" style="width: 128px!important;"  class="text-none ml-4 pa-0 dynamic_header_css">
        <v-icon class="mr-1">mdi-dots-grid</v-icon>
        Fields
        <v-icon class="ml-1 mt-1" size="20">mdi-chevron-down</v-icon>
      </v-btn>
      <!-- <v-text-field density="compact" append-inner-icon="mdi-chevron-down</v-icon>"
        v-bind="props" v-model="Field" prepend-inner-icon="mdi-dots-grid" read-only
        style="width: 150px!important;cursor:pointer !important;font-weight: 600;border-radius: 8px!important;" variant="outlined"
        class="ml-6 filter-custom" @click="openAddHeaderPopup">
      </v-text-field> -->
    </template>
    <v-list class="py-0">
      <v-list-item class="pa-0">
        <v-card style="width: 250px!important;">
            <!-- <v-row> -->
                <div class="mb-4 overflow-y-auto dynamic-height-dis-card">
                  <div v-for="(item,index) of totalHeaderList" :key="index">
                    <!-- <hr class="mx-0 my-2"> -->
                    <v-row class="ml-1 mr-1 mt-3" style="border-bottom: 1px solid #EAEAF4;">
                      <v-col cols="10" class="pa-0 pl-2">
                        <!-- <v-icon>mdi-dots-grid</v-icon> -->
                        <v-label :for='`id${index}`' class="mt-3 v_label_css">
                         <v-icon class="mr-1">mdi-dots-grid</v-icon>
                         <span v-if="item.title.length <= 18">{{ item.title }}</span>
                         <span  v-else>
                          <v-tooltip location="bottom">
                              <template v-slot:activator="{ props }">
                                <span v-bind="props">
                                  {{ item.title.substring(0, 18) + '...' }}
                                </span>
                              </template>
                              <span style="white-space: nowrap;">{{ item.title }}</span>
                            </v-tooltip>
                          </span>
                          </v-label>
                      </v-col>
                      <v-col cols="2" class="pa-0">
                        <v-checkbox-btn v-model="checkBoxList[index].checked" :id='`id${index}`' class="mr-0" color="primary"></v-checkbox-btn>
                      </v-col>                       
                    </v-row>
                  </div>                                     
                </div>                 
            <!-- </v-row> -->
        </v-card>
      </v-list-item>
      <v-card-actions style="position: sticky; bottom: 8px; background: white;">
                      <v-spacer></v-spacer>
                      <v-btn class="text-none" color="indigo" variant="outlined" @click="clearAll">Clear All</v-btn>
                      <v-btn class="text-none" color="primary" variant="flat" @click="callUpdateHeader">Save</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions> 
    </v-list>
    
  </v-menu>
</template>
  <script>
    export default{
      props : {
        headers : Array,
        totalHeaderList : Array,
        updateHeaders : Function,
        componentKey: {               // NEW: key to identify the tab/component
          type: String,
          required: true
        }
      },
      data(){
        return {
          addHeaderPopup : false,
          checkBoxList : [],
          Field : 'Field'
        }
      },
      watch: {
        componentKey: {
          handler() {
            this.loadSavedHeaders();
          },
          immediate: true
        }
      },
      methods : {
         getStorageKey() {
            return `dynamic_headers_${this.componentKey}`;
          },

          // Load headers from localStorage
          loadSavedHeaders() {
            const saved = localStorage.getItem(this.getStorageKey());
             let saved_data = false;
            if (saved) {
              saved_data = true;
              const parsed = JSON.parse(saved);
              this.updateHeaders(parsed); // Pass to parent
            } else {
              saved_data = false;
              this.updateHeaders(this.headers); // Use default from parent
            }
            this.$emit('saved_data_headers', saved_data);
          },

          // Save selected headers to localStorage and update parent
          saveHeaders(headers) {
            localStorage.setItem(this.getStorageKey(), JSON.stringify(headers));
            this.updateHeaders(headers);
          },
        openAddHeaderPopup(){
          this.addHeaderPopup = true;
          this.checkBoxList = [];
          this.totalHeaderList.forEach(header => {
            if(this.headers.some(h => h.key == header.key))
                this.checkBoxList.push({ checked : true });
            else 
                this.checkBoxList.push({ checked : false });
          })
        },
        callUpdateHeader() {
            const header = [];
            this.checkBoxList.forEach((item, index) => {
              if (item.checked) {
                header.push(this.totalHeaderList[index]);
              }
            });

            this.saveHeaders(header);
            this.addHeaderPopup = false;
          },
        clearAll() {
        this.checkBoxList.forEach(item => {
          item.checked = false;
        });
      }
      }
    }
  </script>
  <style>
   :deep(.filter-custom .v-text-field .v-field){
      border-radius: 8px!important;
    }
    :deep(.v_label_css .v-label) {
      color: black !important;
      opacity: 1 !important;
      /* font-size: 14px !important; */
    }
    .v_label_css{
      color: black !important;
      opacity: 1 !important;
    }
    .dynamic_header_css{
      cursor:pointer !important;
      font-weight: 600 !important;
      border-radius: 4px!important;
      border: 1px solid#C7C8D7 !important;
      height : 62px !important;
      padding : 0px !important;
      box-shadow : none !important;
    }
    .dynamic-height-dis-card {
    height: calc(var(--vh, 1vh) * 100 - 530px) !important;
  }
  </style>